























import {Component, Vue, Watch} from 'vue-property-decorator';
import {DataTableHeader} from 'vuetify';
import {getListProducts} from '@/services/ProductService';
import {IProduct} from '@/models/IProduct';
import ProductView from '@/components/ProductView.vue';
import {ModuleShop} from '@/store/modules/ShopModule';
import {ModuleOrganization} from '@/store/modules/OrganizationModule';

@Component({
  components: {
    ProductView
  }
})
export default class ProductsTable extends Vue {
  loading: boolean = true;
  products: IProduct[] = [];
  headers: DataTableHeader[] = [
    {text: 'Product ID', value: 'sp_product_id', width: '120'},
    {text: 'Product', value: ''},
    {text: 'Suppliers', value: ''},
  ];

  get shopId() {
    return ModuleShop.shopId;
  }

  get organizationId() {
    return ModuleOrganization.organizationId;
  }

  @Watch('shopId', {immediate: true})
  async loadData() {
    try {
      this.loading = true;
      this.products = [];
      this.products = await getListProducts(this.organizationId, this.shopId);

    } finally {
      this.loading = false;
    }
  }
}
